module.exports = __webpack_public_path__ + "static/media/spe.8d006eef.png";